/**
 * The two verifications of the tab Aufmaßprotokoll in the order the tab shows them, as the API
 * enum `MeasurementVerificationSide`, and the project field of each state.
 */
export const MEASUREMENT_VERIFICATION_TYPES = ['AC', 'DC'];

export const STATE_TYPE_BY_MEASUREMENT_VERIFICATION_TYPE = {
  AC: 'measurementAcVerificationState',
  DC: 'measurementDcVerificationState',
};
